import * as React from "react";
import styled from "styled-components";
import { LinkContainer } from "components/common";
import { Nav } from "components/bootstrap";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import InactiveNavItem from "./InactiveNavItem";
const StyledNav = styled(Nav)`
  > li > a {
    min-height: ${NAV_ITEM_HEIGHT};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    * {
      cursor: inherit;
    }
  }
`;
const StyledInactiveNavItem = styled(InactiveNavItem)`
  a:hover {
    border: 0;
    text-decoration: none;
  }
`;
const NavBadgeItem = ({ children = void 0, onClick = void 0, to }) => /* @__PURE__ */ React.createElement(StyledNav, { navbar: true }, /* @__PURE__ */ React.createElement(LinkContainer, { to, onClick }, /* @__PURE__ */ React.createElement(StyledInactiveNavItem, null, children)));
export default NavBadgeItem;
